// useDynamicMountParent.ts
import { ref, onUnmounted } from "vue";
import AppInstanceUtils from "@plugins/common/service/app.instance.utils";

export function useDynamicMountParent() {
  const childComponents = ref<any[]>([]);

  onUnmounted(() => {
    if (childComponents.value.length > 0) {
      childComponents.value.forEach((component) => {
        AppInstanceUtils.unmountFromComponent(component);
      });
    }
  });

  return {
    dynamicMountParentMixin_childComponents: childComponents,
  };
}
